import axios from 'axios';
import config from '../config';
import { showError } from '../utils';

// Generic network call function to handle common API request patterns
function networkCall({ method, url, headers, params, data, ...extraOptions }) {
  return axios({
    method,
    url,
    headers,
    params,
    data,
    ...extraOptions,
  })
    .then((resp) => {
      const responseBody = resp.data;
      const responseCode = resp.status;
      if (responseCode === 200 && responseBody.message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        showError(err);
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function insuredApi(authToken) {
  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/console/insure`,
    headers: {
      authorization: authToken,
    },
  });
}

export function newInsuredApi(authToken) {
  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/console/gmc-insure`,
    headers: {
      authorization: authToken,
    },
  });
}

export function InsureTabApi(authToken) {
  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/insure-v2/home?v=161`,
    headers: {
      authorization: authToken,
    },
  });
}

export function InsureTabOpdBenefits(authToken, policyId) {
  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/insure-v2/getOpdPoliciesDetails?policyId=${policyId}`,
    headers: {
      authorization: authToken,
    },
  });
}

export function getFaqData(authToken) {
  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/insure-v2/getallFaq`,
    headers: {
      authorization: authToken,
    },
  });
}

export function getContactMatrix(authToken) {
  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/insure-v2/contactMatrix`,
    headers: {
      authorization: authToken,
    },
  });
}

export function InsureTabIpdBenefits(
  authToken,
  policyId,
  policyType,
  policyNo,
  empId
) {
  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/insure-v2/getIpdPoliciesDetails?policyId=${policyId}&policyFlag=${policyType}&policyNo=${policyNo}&ecode=${empId}`,
    headers: {
      authorization: authToken,
    },
  });
}

export function trackPolicyPayment(transactionId, authToken) {
  // Using direct axios call since this function has different response handling
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(
      `${config.apiBaseUrl}/buy-opd/phonepe/transaction/status/${transactionId}`,
      {
        headers,
      }
    )
    .then((resp) => {
      const responseBody = resp.data;
      return responseBody;
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function getCOI(authToken) {
  // Using direct axios call since this function has different response handling
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(`${config.apiBaseUrl}/buy-opd/user/download-coi`, {
      headers,
    })
    .then((resp) => {
      const responseBody = resp.data;
      return responseBody;
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function activateOpdPolicy(employeeId, authToken) {
  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/new-auth/opd/activate-by-employee-id`,
    data: {
      employeeId,
    },
    headers: {
      authorization: authToken,
    },
  });
}
